import styled from '@themes/theme'

export const FavoriteUserAlertMessageWrap = styled.div`
  position: relative;
  display: flex;
  flex-flow: column;
  justify-content: space-between;

  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 22px 14px 15px 14px;
    &--switch {
      position: absolute;
      left: 0;
      width: 1px;
      height: 1px;
      margin: -1px;
      padding: 0;
      overflow: hidden;
      border: 0;
      clip: rect(0, 0, 0, 0);
      & + .on-off-wrap {
        position: absolute;
        top: 22px;
        right: 24px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 45px;
        height: 24px;
        border-radius: 50px;
        background: ${props => props.theme.color.modalSubBg};
        transition: all .3s;
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 4px;
          display: block;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: ${props => props.theme.color.themeTxt};
          transform: translate(0, -50%);
          transition: all .3s;
        }
      }

      &:checked + .on-off-wrap {
        justify-content: flex-start;
        background: ${props => props.theme.color.primaryBg};
        &::after {
          transform: translate(130%, -50%);
        }
      }
    }
    &--title {
      font-size: ${props => props.theme.font.title};
      font-weight: ${props => props.theme.fontW.bold};
      color: ${props => props.theme.color.modalTxt};
    }
  }
  
  .attached-btn {
    background-color: transparent;
  }

  .message-contents-box {
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 0 21px 0;
    padding: 7px 24px 14px;
    height: 232px;
    &::before {
      content: '';
      display: block;
      position: absolute;
      top: -1px;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 48px);
      height: 1px;
      background-color: ${props => props.theme.color.modalBg};
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: calc(100% - 48px);
      height: 1px;
      background-color: ${props => props.theme.color.modalBg};
    }
    
    &:has(.image-preview-wrap),
    &:has(.shared.link.url) {
      padding-bottom: 10px;
    }
    
    .message-input-wrap {
      position: relative;
      display: flex;
      align-items: flex-start;
      width: 100%;
      height: 100%;
    }
    .text-input {
      flex: 1;
      width: calc((100% - 36px) * 1.33);
      min-width: calc((100% - 36px) * 1.33);
      height: 133%;
      padding: 10px 0 0 0;
      border: none;
      resize: none;
      border-radius: 0;
      color: ${props => props.theme.color.modalTxt};
      font-weight: ${props => props.theme.fontW.medium};
      transform: scale(0.75);
      transform-origin: top left;
      background-color: pink;

      &::placeholder {
        color: ${props => props.theme.color.gray} !important;
      }

      &:active,
      &:hover,
      &:focus {
        border: none !important;
      }
      
      &:disabled {
        color: rgba(183, 183, 183, 0.85);
        &::placeholder {
          color: rgba(183, 183, 183, 0.85) !important;
        }
      }
    }

    .shared.link.url {
      width: 100%;
      padding-top: 18px;
      padding-bottom: 6px;

      .link-wrap {
        display: block;
        height: auto;
        max-height: 50px;
        text-align: left;
        line-height: 1.4rem;

        .attached-link {
          display: block;
          max-height: 50px;
          overflow: scroll;
          color: ${props => props.theme.color.secondaryBg};
          text-decoration: underline;
          word-break: break-all;
          font-size: ${props => props.theme.font.medium};
        }
      }
    }

    .attached-btn {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 36px;
      height: 36px;
      background: none;

      svg {
        width: 22px;
        height: auto;
      }
      
      &:disabled svg {
        path {
          fill: rgba(201, 201, 201, 1);
        }
      }
    }


    .image-preview-wrap {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 72px;
      padding: 9px;
      margin-top: 6px;
      background: ${props => props.theme.color.modalBg};

      .upload-img-preview {
        width: auto;
        max-width: 100%;
        height: 54px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .delete-img-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 42px;
        height: 42px;
        background: none;
        transform: rotate(45deg);

        .x-ico {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          &::before,
          &::after {
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 2px;
            height: 18px;
            border-radius: 10px;
            background: ${props => props.theme.color.gray};
          }

          &::after {
            width: 18px;
            height: 2px;
          }
        }
      }
    }

    &.disabled {
      background-color: ${props => props.theme.color.modalBg};
      .image-preview-wrap {
        background-color: rgba(213, 213, 213, 0.85);
      }
      .upload-img-preview {
        position: relative;
        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(221, 221, 221, 0.85);
        }
        img {
          filter: saturate(0%);
        }
      }
      .delete-img-btn .x-ico {
          &::before,
          &::after {
            background: rgba(201, 201, 201, 0.9);
          }
        }
      .shared.link.url .attached-link {
            color: rgba(183, 183, 183, 0.6);
        }
      }
    }
  }

  .footer {
    padding: 0 14px;
  }
`
